module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/顕微鏡モジュール.13233569.png";